/* eslint-disable class-methods-use-this */
import { ScheduleExtraModel } from "@core/models";

export class ScheduleExtraDTO extends ScheduleExtraModel {
  prepareUpdateScheduleData() {
    return {
      releve_etab_debut_h: this.getStartingHour(),
      releve_etab_debut_min: this.getStartingMinute(),
      releve_etab_nb_heures: this.getScheduleDuration(),
      releve_etab_duree_pause: this.getUpdatedBreakDuration() / 60,
    };
  }

  prepareConfirmScheduleData() {
    return {
      releve_etab_accepte_previsionnel: true,
    };
  }

  prepareDeclareExtraMissingData() {
    return {
      releve_etab_extra_absent: true,
    };
  }

  getStartingHour() {
    const { start } = this.getUpdatedSchedule();
    return Math.floor(start / 60);
  }

  getStartingMinute() {
    const { start } = this.getUpdatedSchedule();
    return start % 60;
  }

  getScheduleDuration() {
    const { start, end, breakDuration } = this.getUpdatedSchedule();
    return (end - start - breakDuration) / 60;
  }
}
